// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomDropdown_custom-dropdown__QQb8j {
  width: 100%;
  cursor: pointer;
  position: relative;
  width: -moz-fit-content;
  width: fit-content;
  display: inline-block;
  box-shadow: 0 0 0 #acacac;
  transition: all 0.4s ease;
}
.CustomDropdown_custom-dropdown__QQb8j * {
  transition: all 0.4s ease;
}
.CustomDropdown_custom-dropdown__QQb8j .CustomDropdown_display-value__eGhRh {
  background-color: #efefef;
  padding: 5px 15px;
  border-radius: 3px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.CustomDropdown_custom-dropdown__QQb8j .CustomDropdown_display-value__eGhRh svg {
  margin-left: 10px;
}
.CustomDropdown_custom-dropdown__QQb8j .CustomDropdown_hidden-values__KqmuP {
  padding-right: 20px;
  height: 0;
  overflow: hidden;
}
.CustomDropdown_custom-dropdown__QQb8j .CustomDropdown_hidden-values__KqmuP div {
  padding: 5px 15px;
}
.CustomDropdown_custom-dropdown__QQb8j .CustomDropdown_all-values__kIYTR {
  z-index: 10;
  position: absolute;
  background-color: white;
  box-shadow: 0 0 0 rgb(172, 172, 172);
  border-radius: 3px;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  height: 0;
  overflow: hidden;
}
.CustomDropdown_custom-dropdown__QQb8j .CustomDropdown_all-values__kIYTR div {
  padding: 5px 15px;
  padding-right: 35px;
}
.CustomDropdown_custom-dropdown__QQb8j .CustomDropdown_all-values__kIYTR div:hover {
  background-color: #f3f3f3;
}
.CustomDropdown_custom-dropdown__QQb8j.CustomDropdown_open__CBiwi {
  box-shadow: 0 3px 3px #acacac;
}
.CustomDropdown_custom-dropdown__QQb8j.CustomDropdown_open__CBiwi .CustomDropdown_display-value__eGhRh {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.CustomDropdown_custom-dropdown__QQb8j.CustomDropdown_open__CBiwi .CustomDropdown_display-value__eGhRh svg {
  transform: rotate(180deg);
}
.CustomDropdown_custom-dropdown__QQb8j.CustomDropdown_open__CBiwi .CustomDropdown_all-values__kIYTR {
  box-shadow: 0 3px 3px rgb(172, 172, 172);
}

.CustomDropdown_custom-dropdown__QQb8j.CustomDropdown_disabled__Oe17G {
  cursor: default;
  opacity: 0.7;
}`, "",{"version":3,"sources":["webpack://./src/Components/CustomDropdown/CustomDropdown.module.scss"],"names":[],"mappings":"AAAA;EACG,WAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,yBAAA;AACH;AACG;EACG,yBAAA;AACN;AAEG;EACG,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAAN;AAEM;EACG,iBAAA;AAAT;AAIG;EACG,mBAAA;EACA,SAAA;EACA,gBAAA;AAFN;AAKM;EACG,iBAAA;AAHT;AAOG;EACG,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,oCAAA;EACA,kBAAA;EACA,0BAAA;EACA,yBAAA;EAEA,SAAA;EACA,gBAAA;AANN;AAQM;EACG,iBAAA;EACA,mBAAA;AANT;AAQS;EACG,yBAAA;AANZ;AAcA;EACG,6BAAA;AAZH;AAcG;EACG,4BAAA;EACA,6BAAA;AAZN;AAcM;EACG,yBAAA;AAZT;AAgBG;EACG,wCAAA;AAdN;;AAkBA;EACG,eAAA;EACA,YAAA;AAfH","sourcesContent":[".custom-dropdown {\n   width: 100%;\n   cursor: pointer;\n   position: relative;\n   width: fit-content;\n   display: inline-block;\n   box-shadow: 0 0 0 #acacac;\n   transition: all 0.4s ease;\n\n   * {\n      transition: all 0.4s ease;\n   }\n\n   .display-value {\n      background-color: #efefef;\n      padding: 5px 15px;\n      border-radius: 3px;\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      align-items: center;\n\n      svg {\n         margin-left: 10px;\n      }\n   }\n\n   .hidden-values {\n      padding-right: 20px;\n      height: 0;\n      overflow: hidden;\n      // white-space: nowrap;\n\n      div {\n         padding: 5px 15px;\n      }\n   }\n\n   .all-values {\n      z-index: 10;\n      position: absolute;\n      background-color: white;\n      box-shadow: 0 0 0 rgb(172, 172, 172);\n      border-radius: 3px;\n      border-top-right-radius: 0;\n      border-top-left-radius: 0;\n      // white-space: nowrap;\n      height: 0;\n      overflow: hidden;\n\n      div {\n         padding: 5px 15px;\n         padding-right: 35px;\n\n         &:hover {\n            background-color: #f3f3f3;\n         }\n      }\n\n      .selected {}\n   }\n}\n\n.custom-dropdown.open {\n   box-shadow: 0 3px 3px #acacac;\n\n   .display-value {\n      border-bottom-left-radius: 0;\n      border-bottom-right-radius: 0;\n\n      svg {\n         transform: rotate(180deg);\n      }\n   }\n\n   .all-values {\n      box-shadow: 0 3px 3px rgb(172, 172, 172);\n   }\n}\n\n.custom-dropdown.disabled {\n   cursor: default;\n   opacity: 0.7;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"custom-dropdown": `CustomDropdown_custom-dropdown__QQb8j`,
	"display-value": `CustomDropdown_display-value__eGhRh`,
	"hidden-values": `CustomDropdown_hidden-values__KqmuP`,
	"all-values": `CustomDropdown_all-values__kIYTR`,
	"open": `CustomDropdown_open__CBiwi`,
	"disabled": `CustomDropdown_disabled__Oe17G`
};
export default ___CSS_LOADER_EXPORT___;
